import type { ReactNode, FC } from 'react'
import { createContext, useContext, useMemo } from 'react'
import type Keycloak from 'keycloak-js'

type ContextType = {
  instance?: Keycloak
}

const initialContext: ContextType = {
  instance: undefined,
}

export const KeycloakInstanceContext = createContext<ContextType>(initialContext)

type Props = {
  instance: Keycloak
  children: ReactNode
}

export const KeycloakInstanceProvider: FC<Props> = ({ instance, children }) => {
  const value: ContextType = useMemo(() => ({ instance }), [instance])

  return <KeycloakInstanceContext.Provider value={value}>{children}</KeycloakInstanceContext.Provider>
}

export const useKeycloakInstance = (): Keycloak => useContext(KeycloakInstanceContext).instance!

export const useKeycloakInstanceSafe = (): Keycloak | undefined => useContext(KeycloakInstanceContext).instance
